<template>
  <div id="permissions-body">
    <!-- Internal Section -->
    <div id="internal" class="collapsible-section">
      <h2 class="subheader">
        Internal
      </h2>
      <VasionButton
        id="internal-collapse-section"
        name="internal-collapse-section"
        class="collapse-section"
        :icon="showInternal ? 'VasionArrowDropDownIcon' : 'VasionArrowDropDownRight16Icon'"
        title="Collapse Section"
        @vasionButtonClicked="toggleInternal()"
      />
      
      <div v-show="showInternal">
        <!-- Internal Users -->
        <div class="setup-row">
          <div class="section-content">
            <VasionListSelection
              :available-fields.sync="availableInternalUsers"
              :selected-fields.sync="assignedInternalUsers"
              :allow-field-ordering="false"
              :available-label-text="'Users'"
              :selected-label-text="'Permitted Users'"
              :unique-id="'permissions-internal-users'"
              @update:availableFields="emitParentFolderIsDirty"
              @update:selectedFields="emitParentFolderIsDirty"
              @update:addAll="emitParentFolderIsDirty"
              @update:removeAll="emitParentFolderIsDirty"
            />
          </div>
        </div>
        
        <div class="subsection-separator"></div>
        
        <!-- Internal Groups -->
        <div class="setup-row">
          <div class="section-content">
            <VasionListSelection
              :available-fields.sync="availableInternalGroups"
              :selected-fields.sync="assignedInternalGroups"
              :allow-field-ordering="false"
              :available-label-text="'Groups'"
              :selected-label-text="'Permitted Groups'"
              :unique-id="'permissions-internal-groups'"
              @update:availableFields="emitParentFolderIsDirty"
              @update:selectedFields="emitParentFolderIsDirty"
              @update:addAll="emitParentFolderIsDirty"
              @update:removeAll="emitParentFolderIsDirty"
            />
          </div>
        </div>
      </div>
    </div>
    
    <div class="separator-div" />
    
    <!-- External Section -->
    <div v-if="showPortalUsers" id="external" class="collapsible-section">
      <h2 class="subheader">
        Portal
      </h2>
      <VasionButton
        id="external-collapse-section"
        name="external-collapse-section"
        class="collapse-section"
        :icon="showExternal ? 'VasionArrowDropDownIcon' : 'VasionArrowDropDownRight16Icon'"
        title="Collapse Section"
        @vasionButtonClicked="toggleExternal()"
      />
      
      <div v-show="showExternal">
        <!-- External Users -->
        <div class="setup-row">
          <div class="section-content">
            <VasionListSelection
              :available-fields.sync="availableExternalUsers"
              :selected-fields.sync="assignedExternalUsers"
              :allow-field-ordering="false"
              :available-label-text="'Users'"
              :selected-label-text="'Permitted Users'"
              :unique-id="'permissions-external-users'"
              @update:availableFields="emitParentFolderIsDirty"
              @update:selectedFields="emitParentFolderIsDirty"
              @update:addAll="emitParentFolderIsDirty"
              @update:removeAll="emitParentFolderIsDirty"
            />
          </div>
        </div>
        
        <div class="subsection-separator"></div>
        
        <!-- External Groups -->
        <div class="setup-row">
          <div class="section-content">
            <VasionListSelection
              :available-fields.sync="availableExternalGroups"
              :selected-fields.sync="assignedExternalGroups"
              :allow-field-ordering="false"
              :available-label-text="'Groups'"
              :selected-label-text="'Permitted Groups'"
              :unique-id="'permissions-external-groups'"
              @update:availableFields="emitParentFolderIsDirty"
              @update:selectedFields="emitParentFolderIsDirty"
              @update:addAll="emitParentFolderIsDirty"
              @update:removeAll="emitParentFolderIsDirty"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PortalParentFolderPermissions',
  props: {
    showPortalUsers: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: function () {
    return {
      assignedInternalGroups: [],
      assignedInternalUsers: [],
      assignedExternalGroups: [],
      assignedExternalUsers: [],
      availableInternalGroups: [],
      availableInternalUsers: [],
      availableExternalGroups: [],
      availableExternalUsers: [],
      showInternal: true,
      showExternal: true,
      values: {},
    }
  },
  computed: {
    groupList() { return this.$store.state.security.groupList },
    userList() { return this.$store.state.security.userList },
  },
  methods: {
    toggleInternal() {
      this.showInternal = !this.showInternal
    },
    toggleExternal() {
      this.showExternal = !this.showExternal
    },
    buildPermissionsSaveDataJSON() {
      // Combine internal and external users and groups
      const payload = {
        assignedUsers: [
          ...this.assignedInternalUsers.map((user) => user?.value).filter(e => e != null),
          ...this.assignedExternalUsers.map((user) => user?.value).filter(e => e != null)
        ],
        assignedGroups: [
          ...this.assignedInternalGroups.map((group) => group?.value).filter(e => e != null),
          ...this.assignedExternalGroups.map((group) => group?.value).filter(e => e != null)
        ],
      }

      return payload
    },
    buildUsersAndGroups(values) {
      if (values && values.userAccess && values.userAccess.length > 0) {
        values.userAccess.forEach((element) => {
          // Find user in available internal users
          let aUser = this.availableInternalUsers.find(user => user.value === element)
          if (aUser) {
            this.assignedInternalUsers.push(aUser)
            this.availableInternalUsers = this.availableInternalUsers.filter(user => user.value !== element)
          } else {
            // If not found in internal users, check external users
            aUser = this.availableExternalUsers.find(user => user.value === element)
            if (aUser) {
              this.assignedExternalUsers.push(aUser)
              this.availableExternalUsers = this.availableExternalUsers.filter(user => user.value !== element)
            }
          }
        })
      }
      
      if (values && values.groupAccess && values.groupAccess.length > 0) {
        values.groupAccess.forEach(element => {
          // Find group in available internal groups
          let aGroup = this.availableInternalGroups.find(group => group.value === element)
          if (aGroup) {
            this.assignedInternalGroups.push(aGroup)
            this.availableInternalGroups = this.availableInternalGroups.filter(group => group.value !== element)
          } else {
            // If not found in internal groups, check external groups
            aGroup = this.availableExternalGroups.find(group => group.value === element)
            if (aGroup) {
              this.assignedExternalGroups.push(aGroup)
              this.availableExternalGroups = this.availableExternalGroups.filter(group => group.value !== element)
            }
          }
        })
      }
    },
    emitParentFolderIsDirty() {
      this.updateParentFolderPermissionsPayload()
      this.$emit('markAsDirty', true)
    },
    async reloadParentFolderData() {
      const [enabledUserList] = await Promise.all([
        this.$store.dispatch('security/getUserListEnabledOnly'),
        this.$store.dispatch('security/loadGroupList')
      ]);
      
      // Reset all arrays
      this.assignedInternalGroups = []
      this.assignedInternalUsers = []
      this.assignedExternalGroups = []
      this.assignedExternalUsers = []
      this.availableInternalGroups = []
      this.availableInternalUsers = []
      this.availableExternalGroups = []
      this.availableExternalUsers = []

      // Separate groups into internal and external
      this.groupList.forEach((element) => {
        const group = {
          value: element.ID,
          name: element.Name,
          isPortalGroup: element.isPortalGroup
        }
        
        if (element.isPortalGroup) {
          this.availableExternalGroups.push(group)
        } else {
          this.availableInternalGroups.push(group)
        }
      })

      // Separate users into internal and external
      enabledUserList.forEach((element) => {
        const user = {
          value: element.UserId,
          name: element.Username,
          isPortalUser: element.IsPortalUser
        }
        
        if (element.IsPortalUser) {
          this.availableExternalUsers.push(user)
        } else {
          this.availableInternalUsers.push(user)
        }
      })
    },
    async setValues(values) {
      await this.reloadParentFolderData()
      if (this.availableInternalUsers.length > 0 || this.availableExternalUsers.length > 0) {
        this.buildUsersAndGroups(values)
      } else {
        this.values = values
      }

      this.updateParentFolderPermissionsPayload()
    },
    updateParentFolderPermissionsPayload() {
      const payload = this.buildPermissionsSaveDataJSON()
      this.$store.dispatch('admin/setParentFolderPermissions', payload)
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '@/assets/css/variables.scss';
  
  .separator-div {
    height: 40px;
  }
  
  .subsection-separator {
    height: 20px;
    clear: both;
  }
  
  .collapsible-section {
    float: left;
    margin-top: 20px;
    width: 100%;
    
    .subheader {
      @include SubHeadline;
      width: 200px;
      display: block;
      float: left;
      margin-top: 5px;
    }
    
    .collapse-section {
      float: left;
    }
  }
  
  .setup-row {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    margin: 6px 0;
    clear: both;
  }
  
  .section-content {
    width: 100%;
  }
  
  .subsection-header {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
    color: $grey-700;
  }
</style>
